import { Buffer } from 'buffer'
const dicomFileChecker = input => {
  if (!(input instanceof Uint8Array || input instanceof ArrayBuffer || Buffer.isBuffer(input))) {
    throw new TypeError(
      `Expected the \`input\` argument to be of type \`Uint8Array\` or \`Buffer\` or \`ArrayBuffer\`, got \`${typeof input}\``
    )
  }

  const buffer = Buffer.from(input)

  if (!(buffer && buffer.length > 1)) {
    return
  }

  const check = (header, options) => {
    options = {
      offset: 0,
      ...options
    }

    for (let i = 0; i < header.length; i++) {
      // If a bitmask is set
      if (options.mask) {
        // If header doesn't equal `buf` with bits masked off
        if (header[i] !== (options.mask[i] & buffer[i + options.offset])) {
          return false
        }
      } else if (header[i] !== buffer[i + options.offset]) {
        return false
      }
    }

    return true
  }

  if (check([0x44, 0x49, 0x43, 0x4d], { offset: 128 })) {
    return {
      ext: 'dcm',
      mime: 'application/dicom'
    }
  }
}

export default dicomFileChecker

Object.defineProperty(dicomFileChecker, 'minimumBytes', { value: 4100 })
